export enum SourceId {
  Nzt = 'NZT',
  Aut = 'AUT',
  Tss = 'TSS',
  Gpp = 'GPP',
  Klr = 'KLR',
  Swe = 'SWE',
  Mbp = 'MBP',
  Swh = 'SWH',
  Vps = 'VPS',
  Ppp = 'PPP',
  Vpe = 'VPE',
  Mpe = 'MPE',
  Cre = 'CRE',
  Pwy = 'PWY',
  Opx = 'OPX',
  Opb = 'OPB',
  Afe = 'AFE',
  Scn = 'SCN',
  Ocs = 'OCS',
  Icg = 'ICG',
  Pbx = 'PBX',
  Pww = 'PWW',
  Pwc = 'PWC',
  Apg = 'APG',
  Dbx = 'DBX',
  Ppe = 'PPE',
  Cry = 'CRY',
  Alp = 'ALP',
  Wch = 'WCH',
  Kli = 'KLI',
  Afm = 'AFM',
  Fdb = 'FDB',
  Blk = 'BLK',
  Prm = 'PRM',
}
